import React, { Component } from "react";

import { auth } from "src/helpers/Firebase";
import { TopBar } from "../../layouts/general/index";
import { TitleHeading } from "../../layouts/home/index";

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      logged: false,
      email: "",
      password: "",
      headingchoose: [
        {
          id: 1,
          classnames: "heading",
          title: "Login",
          showIcon: false,
        },
      ],
    };
  }

  onSubmit() {
    const { email, password } = this.state;
    const { history, location } = this.props;

    auth
      .signInWithEmailAndPassword(email, password)
      .then(() => {
        this.setState({ logged: true });
        //history.push(location.state?.from?.pathname || "/admin/home");
      })
      .catch((error) => console.log(error));
  }

  render() {
    const { email, password } = this.state;

    return (
      <div className="header-fixed page no-sidebar header-style-2 topbar-style-2 menu-has-search">
        <div id="wrapper" className="animsition">
          <div id="page" className="clearfix">
            <div id="site-header-wrap">
              <TopBar />
            </div>
            <div id="main-content" className="site-main clearfix">
              <div id="content-wrap">
                <div id="site-content" className="site-content clearfix">
                  <div id="inner-content" className="inner-content-wrap">
                    <div className="page-content">
                      <div className="row-iconbox">
                        <div className="container">
                          <div className="row">
                            {this.state.logged == true ? (
                              <div
                                className="col-md-12"
                                style={{ margin: "50px 0" }}
                              >
                                <center>
                                  <p>
                                    Dobar dan dragi administratoru CityX-a!
                                    <br />
                                    <br />
                                    Uspješno si prijavljen
                                  </p>
                                  <a href="/admin/home">
                                    <button type="button">ULAZAK</button>
                                  </a>
                                </center>
                              </div>
                            ) : (
                              <div className="col-md-12">
                                {this.state.headingchoose.map((data) => (
                                  <TitleHeading data={data} key={data.id} />
                                ))}

                                <div>
                                  <p>Email</p>
                                  <input
                                    className="col-12"
                                    type="text"
                                    onChange={(e) =>
                                      this.setState({ email: e.target.value })
                                    }
                                    value={email}
                                  />

                                  <p>Password</p>
                                  <input
                                    className="col-12 mb-2"
                                    type="password"
                                    onChange={(e) =>
                                      this.setState({
                                        password: e.target.value,
                                      })
                                    }
                                    value={password}
                                  />

                                  <input
                                    type="button"
                                    onClick={() => this.onSubmit()}
                                    value="Login"
                                  />
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Login;
